'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _helpersApiClient = require('../../helpers/ApiClient');

var _helpersApiClient2 = _interopRequireDefault(_helpersApiClient);

var _reactisLoader = require('reactis-loader');

var _components = {
	_$Chart: {
		displayName: 'Chart'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Chart = (function (_Component) {
	_inherits(Chart, _Component);

	function Chart(props) {
		_classCallCheck(this, _Chart);

		_Component.call(this, props);
		this.state = {
			values: [],
			pending: false
		};
	}

	Chart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.metric != this.props.metric) {
			this.reload(nextProps.metric);
		}
	};

	Chart.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
		if (prevState.values != this.state.values) {
			this.initChart();
		}
	};

	Chart.prototype.componentDidMount = function componentDidMount() {
		this.reload();
	};

	Chart.prototype.getMetricTitle = function getMetricTitle() {
		return _dbinfo2['default'].Metric.get(this.props.metric);
	};

	Chart.prototype.initChart = function initChart() {
		var metric = this.getMetricTitle();

		this.chart = new Highcharts.Chart({
			chart: {
				renderTo: 'container',
				zoomType: 'x',
				animation: false
			},
			title: {
				text: metric
			},
			subtitle: {
				text: document.ontouchstart === undefined ? 'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in'
			},

			credits: {
				enabled: false
			},

			legend: {
				enabled: false
			},

			xAxis: {
				type: 'datetime',
				minRange: 3600000 * 4,
				labels: {
					style: {
						fontSize: '12px'
					}
				}
			},

			yAxis: {
				title: {
					text: ''
				},
				labels: {
					style: {
						fontSize: '12px'
					}
				}
			},

			plotOptions: {
				area: {
					fillColor: {
						linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
						stops: [[0, Highcharts.getOptions().colors[0]], [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]]
					},
					marker: {
						radius: 2
					},
					lineWidth: 1,
					states: {
						hover: {
							lineWidth: 1
						}
					},
					threshold: null
				}
			},

			series: [{
				type: 'area',
				name: metric,
				pointInterval: 60 * 1000,
				pointStart: _moment2['default'](this.state.start).toDate().getTime(),
				data: this.state.values
			}]
		});
	};

	Chart.prototype.reload = function reload() {
		var _this = this;

		var metric = arguments.length <= 0 || arguments[0] === undefined ? this.props.metric : arguments[0];

		if (this.chart) {
			this.chart.destroy();
		}

		this.setState({
			pending: true
		});

		var client = new _helpersApiClient2['default']();
		client.call('data.getChart', { metric: metric }).then(function (result) {
			_this.setState({
				values: result.values,
				start: result.start,
				pending: false
			});
		});
	};

	Chart.prototype.render = function render() {
		var metric = this.getMetricTitle();
		return _react2['default'].createElement(
			'div',
			{ id: 'container', style: { position: 'relative', height: 650 } },
			_react2['default'].createElement(_reactisLoader.Loader, { visible: true, opacity: 1, background: 'transparent' })
		);
	};

	var _Chart = Chart;
	Chart = _wrapComponent('_$Chart')(Chart) || Chart;
	return Chart;
})(_componentsComponent2['default']);

exports['default'] = Chart;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Chart/Chart.js
 ** module id = 964
 ** module chunks = 2
 **/